<template>
    <select :id="id" class="select2" :multiple="multiple" :disabled="disabled" :placeholder="placeholder">
        <option></option>
        <slot></slot>
    </select>
</template>

<script>
import jQuery from 'jquery';

import uuid from '../../library/uuid';
import select2Tools from '../../library/select2-tools';

export default {
    props: {
        id: {
            default: uuid()
        },
        disabled: {
            default: false
        },
        multiple: {
            default: false
        },
        placeholder: {
            default: null
        },
        value: {
            default: null
        }
    },
    watch: {
        value(newValue, oldValue) {
            this.myValue = newValue;
            if (this.select2 === null) return;
            if (this.select2.hasClass('tags')) this.checkOptions(newValue);
            this.setValue(this.myValue);
        }
    },
    data() {
        return {
            myValue: null,
            select2: null
        };
    },
    mounted() {
        this.myValue = this.value;
        this.$nextTick(this.renderView);
    },
    methods: {
        renderView() {
            let component = this;
            this.select2 = select2Tools.initSelect2(this.$el);
            this.select2.on('input', function () {
                component.$emit('input', jQuery(this).val());
            });
            this.select2.on('change', function () {
                component.$emit('change', jQuery(this).val());
            });
            if (this.myValue) this.setValue(this.myValue);
        },
        setValue(value) {
            if (this.select2) {
                if (this.select2.hasClass('tags')) this.checkOptions(this.myValue);
                this.select2.val(this.myValue).trigger('change');
            }
        },
        checkOptions(value) {
            if (value instanceof Array) {
                value.forEach(sub_value => this.checkOption(sub_value));
            } else {
                this.checkOption(value);
            }
        },
        checkOption(value) {
            if (value === undefined || value === null) return;
            if (this.select2.find(`option[value="${value}"]`).length) {
                return;
            } else {
                this.addTag(value);
                return;
            }
        },
        addTags(options) {
            if (typeof options.forEach === 'function') {
                options.forEach(option => this.addTag(option));
            } else {
                this.addTag(options);
            }
            return;
        },
        addTag(option) {
            let newOption = this.resolveOption(option);
            newOption.setAttribute('data-select2-tag', true);
            this.select2.append(newOption);
            return;
        },
        addOptions(options) {
            if (typeof options.forEach === 'function') {
                options.forEach(option => this.addOption(option));
            } else {
                this.addOption(options);
            }
            return;
        },
        addOption(option) {
            let newOption = this.resolveOption(option);
            this.select2.append(newOption);
            return;
        },
        resolveOption(option) {
            if (option === undefined || option === null) return;
            let newOption = new Option();
            if (typeof option === 'object') {
                if (option.text && option.value) {
                    newOption.text = option.text;
                    newOption.value = option.value;
                } else {
                    return;
                }
            } else {
                newOption.text = option;
                newOption.value = option;
            }
            return newOption;
        }
    }
}
</script>
